import React from "react";
import { Award } from "lucide-react";

// Tier -> visual config (Gold/Silver/Standard).
const CONFIG = {
  gold:     { label: "Gold Verified",     cls: "bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-950 border-amber-500/50", iconColor: "text-amber-950" },
  silver:   { label: "Silver Verified",   cls: "bg-gradient-to-r from-slate-300 to-slate-400 text-slate-900 border-slate-400/60", iconColor: "text-slate-900" },
  standard: { label: "Verified Supplier", cls: "bg-white text-secondary border-border", iconColor: "text-primary" },
};

export default function TierBadge({ tier = "standard", size = "sm", showLabel = true, testid }) {
  const cfg = CONFIG[tier] || CONFIG.standard;
  const px = size === "lg" ? "px-4 py-2 text-sm" : size === "md" ? "px-3 py-1.5 text-xs" : "px-2.5 py-1 text-[11px]";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-bold border ${cfg.cls} ${px}`} data-testid={testid || `tier-${tier}`}>
      <Award className={`w-3.5 h-3.5 ${cfg.iconColor}`} />
      {showLabel && <span className="uppercase tracking-wider">{cfg.label}</span>}
    </span>
  );
}
